/* eslint max-classes-per-file: 0 */

import {
  Formdata as Data,
  FormdataCollection as Collection,
} from '@/typings/api/Formdata'
import { LkFormdataApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class LKFormdataTransformerParams extends TransformerParams {
  protected defaultParams = [
    'data_collection_id',
    'form_data_id',
  ];
}


export class LKFormdataAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new LKFormdataTransformerParams();
}
